import React from 'react';
export function Footer() {
  return <footer className="bg-brand-black py-12 border-t border-white/10 pb-28 md:pb-12" data-id="element-41">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-42">
        <div className="font-serif text-2xl font-bold tracking-wider text-white mb-4 opacity-50" data-id="element-43">
          AURA BIT
        </div>
        <p className="text-gray-500 text-sm mb-6" data-id="element-44">
          Un producto de AURA BIT. Herramientas reales para profesionales de la
          estética en Argentina.
        </p>
        <div className="flex items-center justify-center gap-6 text-xs text-gray-600" data-id="element-45">
          <a href="#" className="hover:text-brand-pink transition-colors" data-id="element-46">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-brand-pink transition-colors" data-id="element-47">
            Políticas de Privacidad
          </a>
          <a href="#" className="hover:text-brand-pink transition-colors" data-id="element-48">
            Contacto
          </a>
        </div>
      </div>
    </footer>;
}